import React, { Component } from "react";
import { exportComponentAsPNG } from "react-component-export-image";
import GetAppIcon from "@material-ui/icons/GetApp";
import Button from "@material-ui/core/Button";
import IconButton from "@mui/material/IconButton";
import CloseIcon from "@mui/icons-material/Close";
import Dialog from "@material-ui/core/Dialog";
// import DialogActions from "@material-ui/core/DialogActions";
import DialogContent from "@material-ui/core/DialogContent";
import DialogTitle from "@material-ui/core/DialogTitle";
import FetchServerData from "../../../provider/FetchServerData";
import store from "../../../redux/store";
import { GetQRCode_Url } from "../../../provider/ServiceUrl";
import Utils from "../../../provider/Utils";
import PtsAlert from "../ptsAlert/PtsAlert";
class QRCodeDialog extends Component {
  header = store.getState().header.header;

  constructor(props) {
    super(props);
    this.imageDwlRef = React.createRef();
    this.state = {
      qrcodeimg: "",
      keyword: "",
      messageName: "",
      initialPage: 0,
      pageSize: 10,
      activityList: [],
      open: false,
    };
  }

  showQRCode(rowData) {
    const postObject = {
      header: this.header,
      smsMessage: {
        id: rowData.id,
      },
    };
    FetchServerData.callPostService(GetQRCode_Url, postObject).then(
      (output) => {
        if (Utils.equalsIgnoreCase(output.status, "SUCCESS")) {
          window.scrollTo(0, 0);
          let qrcodeimg = output.data.qrCode;
          this.setState({
            qrcodeimg: qrcodeimg,
            keyword: rowData?.keyword,
            messageName: rowData?.messagename,
            open: true,
          });
        } else {
        }
      }
    );
  }

  handleOpen() {
    this.setState({ open: true });
  }

  handleClose() {
    this.setState({ open: false });
  }

  downloadImage() {
    let fileName = `QRcode_txt_kywrd_${this.state.keyword}`;

    exportComponentAsPNG(this.imageDwlRef, {
      fileName,
      html2CanvasOptions: {
        scale: 3,
        dpi: 300,
        backgroundColor: "#ffffff",
        useCORS: true,
        onclone: (clonedDoc) => {
          const legend = clonedDoc.getElementById("legend");
          if (legend) {
            legend.style.visibility = "visible";
          }
        },
      },
    });
  }

  copyQrCode = async () => {
    try {
      const img = this.qrImgRef.current;
      if (!img) return;

      // Convert base64 image to blob
      const response = await fetch(img.src);
      const blob = await response.blob();

      await navigator.clipboard.write([
        new ClipboardItem({
          [blob.type]: blob,
        }),
      ]);

      PtsAlert.success("QR code copied to clipboard");
    } catch (err) {
      PtsAlert.error("Copy not supported in this browser");
    }
  };

  render() {
    this.qrImgRef = React.createRef();
    return (
      <>
        <Dialog
          open={this.state.open}
          onClose={this.handleClose.bind(this)}
          maxWidth="xl"
          className="MsgQRCodeDialogue"
        >
          <DialogTitle id="scroll-dialog-title">
            <span style={{ color: "#fff" }}>Test and Download QR Code</span>
          </DialogTitle>
          <IconButton
            aria-label="close"
            onClick={this.handleClose.bind(this)}
            style={{
              position: "absolute",
              right: 8,
              top: 4,
              color: (theme) => theme.palette.grey[500],
            }}
          >
            <CloseIcon style={{ color: "#fff", fontWeight: "600" }} />
          </IconButton>
          <DialogContent>
            <div
              style={{
                width: "100%",
                color: "#000",
                fontSize: "small",
                padding: "0.5em",
              }}
            >
              <div className="col-sm-12">
                <div className="row d-flex">
                  <div className="col-sm-6">
                    <div className="row mt-4 text-center">
                      <div
                        className="col-sm-12"
                        ref={this.imageDwlRef}
                        style={{
                          // height: "280px",
                          textAlign: "left",
                        }}
                      >
                        <label
                          className="form-label fs-5 align-self-end mb-0"
                          htmlFor="collapsible-firstname"
                          style={{ color: "#337ab7" }}
                        >
                          QR Code
                        </label>
                        <div className="row mt-2">
                          <label
                            className="col-sm-4 form-label fs-6 align-self-start mb-0 pe-0"
                            htmlFor="collapsible-firstname"
                          >
                            Keyword:
                          </label>
                          <div className="col-sm-8 ps-0 fw-bold">
                            {this.state.keyword}
                          </div>
                        </div>
                        <div className="row mt-2">
                          <label
                            className="col-sm-4 form-label fs-6 align-self-start mb-0 pe-0"
                            htmlFor="collapsible-firstname"
                          >
                            Message Title:
                          </label>
                          <div className="col-sm-8 ps-0 fw-bold">
                            {this.state.messageName}
                          </div>
                        </div>
                        <p className="mt-3" style={{ fontSize: "14px" }}>
                          This QR code simplifies the send-keyword process by
                          loading the keyword and phone number into the person’s
                          phone so they only have to tap Send.
                        </p>
                        <p style={{ fontSize: "14px" }}>
                          Printing or sharing this code? Test it first!
                        </p>
                      </div>
                    </div>
                  </div>
                  <div className="col-sm-6">
                    <div
                      ref={this.imageDwlRef}
                      style={{
                        padding: "16px 16px 0px 0px",
                        // width: "320px",
                        backgroundColor: "#fff",
                        textAlign: "center",
                      }}
                    >
                      <img
                        ref={this.qrImgRef}
                        src={`data:image/png;base64,${this.state.qrcodeimg}`}
                        alt="QR Code"
                        style={{
                          // width: "280px",
                          height: "280px",
                          margin: "0 auto",
                          display: "block",
                        }}
                      />

                      {/* Hidden in UI */}
                      <p
                        id="legend"
                        className="mb-0"
                        style={{
                          visibility: "hidden",
                          fontSize: "12px",
                          lineHeight: "16px",
                          // width: "280px",
                          textAlign: "center",
                        }}
                      >
                        Msg &amp; data rates apply. Text "STOP" to opt-out.
                        <br />
                        See our website for SMS terms of service.
                      </p>
                    </div>
                    <div className="row ps-0">
                      <div className="col-sm-12 text-center">
                        <Button
                          id="downloadExcelButton"
                          type="button"
                          variant="contained"
                          className="btn success"
                          startIcon={
                            <i
                              className="fa fa-download"
                              style={{ fontSize: "16px" }}
                            ></i>
                          }
                          onClick={(e) => this.downloadImage(e)}
                        >
                          Download
                        </Button>
                        &nbsp; &nbsp;
                        <Button
                          id="copyQrButton"
                          variant="contained"
                          type="button"
                          className="btn success"
                          startIcon={
                            <i className="fa fa-copy" style={{ fontSize: "16px" }}></i>
                          }
                          onClick={(e) => this.copyQrCode(e)}
                        >
                          Copy
                        </Button>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </DialogContent>
        </Dialog >
      </>
    );
  }
}
export default QRCodeDialog;
